export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5607.4af98099.jpg";